export enum SearchType {
    MEMBER = 'member',
    EVENT = 'event',
    REPLAY = 'replay',
    BENEFIT = 'benefit',
    ARTICLE = 'article',
}
